import React from "react";
import PropTypes from "prop-types";
import styled from "theme/libs/styled";
import Heading from "theme/components/contentBlocks/TextSection/sections/Heading";
import SubHeading from "theme/components/contentBlocks/TextSection/sections/SubHeading";
import Ingress from "theme/components/contentBlocks/TextSection/sections/Ingress";
import Paragraph from "theme/components/contentBlocks/TextSection/sections/Paragraph";
import { above } from "core-web/utils/mediaqueries";

const Wrapper = styled("div")`
    ${above.tabletLg} {
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        > * {
            grid-column: 4 / span 6;
        }
    }
`;

const Sections = ({ sections, isCustomerService }) => (
    <Wrapper>
        {/* @TODO: Look over multiple if statements. Make a mapping instead? */}
        {(sections || []).map((section, index) => {
            if (section?.layout === "heading") {
                return <Heading key={index} data={section.heading} isCustomerService={isCustomerService} />;
            }
            if (section?.layout === "sub_heading") {
                return <SubHeading key={index} data={section.sub_heading} />;
            }
            if (section?.layout === "ingress") {
                return <Ingress key={index} data={section.ingress} isCustomerService={isCustomerService} />;
            }
            if (section?.layout === "paragraph") {
                return <Paragraph key={index} data={section.paragraph} isCustomerService={isCustomerService} />;
            }
            return null;
        })}
    </Wrapper>
);

Sections.propTypes = {
    sections: PropTypes.array,
    isCustomerService: PropTypes.bool,
};

Sections.defaultProps = {
    sections: [],
    isCustomerService: false,
};

export default Sections;
